import BankingOperation from '../../Operation'
import BillPaymentForm from '../../Forms/BillPaymentForm'

export default function BankingBill ({ requestConfig, onCompleted, ...props }) {
  return (
    <BankingOperation title='Boleto' {...props}>
      {({ availableBalance }) => (
        <BillPaymentForm
          availableBalance={availableBalance}
          requestConfig={requestConfig}
          onCompleted={onCompleted}
        />
      )}
    </BankingOperation>
  )
}
